import styled from 'styled-components';
import { motion } from 'framer-motion';
import { zIndexes } from 'style/theme';
import { sizes } from 'style';

export const Backdrop = styled(motion.div)`
  position: fixed;
  z-index: ${zIndexes.navigation - 1};
  display: flex;
  bottom: 0;
  left: 0;
  top: 55px;
  height: calc(100vh - 55px - ${({ barHeight }) => `${barHeight || 0}px`});
  width: 100%;
  overflow: scroll;
  transition: background 200ms;

  background: transparent
    linear-gradient(
      0deg,
      #273c49 0%,
      #273c49fd ${({ gradientPercentage }) => gradientPercentage + 5}%,
      #273c4900 100%
    )
    0% 0% no-repeat padding-box;

  @media ${sizes.desktop} {
    top: 60px;
    height: calc(100vh - 60px - ${({ barHeight }) => `${barHeight || 0}px`});
  }
`;

export const ControlHeight = styled.div`
  height: 100vh;
  width: 0;
  position: absolute;
`;

export const OverlayChildren = styled(motion.div)`
  display: flex;
  margin: 0 auto;
  align-items: ${({ gradientPercentage }) =>
    gradientPercentage > 90 ? 'flex-start' : 'flex-end'};
  padding: 0 40px;
  max-width: 1600px;
  width: 100%;
  min-height: 630px;
  height: 100%;
  z-index: 1;
`;
